<template>
  <div class="">
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="10">
        <el-col :md="12" :lg="12">
          <shop-select v-if="$store.getters.login_type != 'distributor'" distributors  @update="storeSearch"></shop-select> <!--distributors wxshops 需要哪个api传哪个-->
        </el-col>
        <el-col :md="10" :lg="8">
          <el-date-picker v-model="create_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="7" :lg="5">
          <el-select v-model="order_class" @change="TypeHandle" placeholder="请选择订单类型"
                     style="width: 100%;" size="mini">
            <el-option
                    v-for="(item, index) in order_class_array"
                    :key="index"
                    :label="item.name"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="7" :lg="5">
          <el-autocomplete
                  class="inline-input"
                  v-model="source_name"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入来源"
                  @select="sourceSearch"
                  size="mini"
          ></el-autocomplete>
        </el-col>
<!--        <el-col :md="7" :lg="5">-->
<!--          <el-select v-model="source" @change="TypeHandle" placeholder="请选择来源类型"-->
<!--                     style="width: 100%;" size="mini">-->
<!--            <el-option-->
<!--              v-for="(item, index) in order_third_array"-->
<!--              :key="index"-->
<!--              :label="item.name"-->
<!--              :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-col>-->
        <el-col :md="7" :lg="5">
          <el-input placeholder="导购员手机号" v-model="salesman_mobile" size="mini"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :md="7" :lg="5">
          <el-input placeholder="手机号/订单号" v-model="identifier" size="mini"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>

      </el-row>
      <el-row :gutter="10">
        <el-col :md="7" :lg="5">
          <el-select  v-model="pay_type" @change="TypePayHandle" placeholder="请选择支付方式类型" style="width: 100%;" size="mini">
            <el-option
              v-for="(item, index) in pay_type_array"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="10" :lg="5">
          <el-input placeholder="商品货号，多个货号间使用英文逗号分割" v-model="item_bn" size="mini"><el-button slot="append" icon="el-icon-search" @click="itemBnSearch"></el-button></el-input>
        </el-col>
        <el-col :md="3" :lg="3">
          <el-select  v-model="merchant_type" @change="TypePayHandle" placeholder="全部订单" size="mini">
            <el-option
              v-for="(item, index) in merchantType"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="3" :lg="3">
          <el-select  v-model="push_to_youxuan_status" @change="sourceChange" placeholder="全部订单" size="mini">
            <el-option
              v-for="(item, index) in sourceType"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="3" :lg="3">
          <el-select  v-model="receipt_type" @change="receiptTypeChange" placeholder="取货方式" size="mini">
            <el-option
              v-for="(item, index) in receiptType"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="6" :lg="5">
          <el-button-group>
            <el-button size="mini" type="primary" @click="exportData('normal_master_order')" >导出主订单</el-button>
            <el-button size="mini" type="primary" @click="exportData('normal_order')" >导出</el-button>
          </el-button-group>
          <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="订单下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待发货" name="notship"></el-tab-pane>
         <el-tab-pane label="待收货" name="WAIT_BUYER_CONFIRM"></el-tab-pane>
        <el-tab-pane label="已完成" name="done"></el-tab-pane>
        <el-tab-pane label="未支付" name="notpay"></el-tab-pane>
        <el-tab-pane label="取消待审核" name="cancelapply"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        <el-table :data="list" style="width: 100%" :height="wheight-190" v-loading="loading" element-loading-text="数据加载中" @sort-change="sortChange">
          <el-table-column type="expand" fixed>
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand" label-width="120px">
                <el-form-item label="所属店铺">
                  <span v-if="scope.row.distributor_name">{{scope.row.distributor_name}}</span>
                  <span v-else>总部-怡康大庆路二店</span>
                </el-form-item>
                <el-form-item label="运费">
                  <span>{{scope.row.fee_symbol}}{{scope.row.freight_fee / 100}}</span>
                </el-form-item>
                <!-- <el-form-item label="处方审核状态">
                  <span v-if="scope.row.prescription_review == 0 && scope.row.order_drug == 1">待审核</span>
                  <span v-if="scope.row.prescription_review == 1 && scope.row.order_drug == 1">已通过</span>
                  <span v-if="scope.row.prescription_review == 2 && scope.row.order_drug == 1">未通过</span>
                </el-form-item>
                <el-form-item label="订单审核状态">
                  <span v-if="scope.row.prescription_order_status == 0 && scope.row.order_drug == 1">待审核</span>
                  <span v-if="scope.row.prescription_order_status == 1 && scope.row.order_drug == 1">已通过</span>
                  <span v-if="scope.row.prescription_order_status == 2 && scope.row.order_drug == 1">未通过</span>
                </el-form-item> -->
                <el-form-item label="订单类型">
                  <span v-if="scope.row.order_class=='normal'">普通订单</span>
                  <span v-if="scope.row.order_class=='groups'">团购订单</span>
                  <span v-if="scope.row.order_class=='seckill'">秒杀订单</span>
                  <span v-if="scope.row.order_class=='community'">社区订单</span>
                </el-form-item>
                <el-form-item label="是否为服务订单">
                  <span v-if="scope.row.is_settle_in_service == '1'">服务</span>
                  <span v-else-if="scope.row.is_settle_in_service == '0'">普通</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="order_id" label="订单号" fixed></el-table-column>
          <el-table-column prop="create_time" label="创建时间" sortable="custom" v-if="params.order_status != 'cancelapply'">
            <template slot-scope="scope">
              <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cancel_time" label="申请退款时间" sortable="custom" v-else>
            <template slot-scope="scope" v-if="scope.row.cancel_time>0">
              <span>{{scope.row.cancel_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="distributor_name" label="所属店铺" >
            <template slot-scope="scope">
              <span v-if="scope.row.distributor_name">{{scope.row.distributor_name}}</span>
              <span v-else>总部-怡康大庆路二店</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column width="50" label="运费" style="border: 1px solid red">
            <template slot-scope="scope">
              {{scope.row.fee_symbol}}{{scope.row.freight_fee / 100}}
            </template>
          </el-table-column> -->
          <!--
          <el-table-column width="70" label="商品金额">
            <template slot-scope="scope">
              {{scope.row.fee_symbol}}{{scope.row.item_fee / 100}}
            </template>
          </el-table-column>
          -->
          <el-table-column prop="total_fee" width="75" label="金额">
            <template slot-scope="scope">
              {{scope.row.fee_symbol}}{{scope.row.total_fee / 100}}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" width="111" label="手机号"></el-table-column>
          <!-- <el-table-column  width="80" label="订单类型" style="border:1px solid red">
            <template slot-scope="scope">
              <span v-if="scope.row.order_class=='normal'">普通订单</span>
              <span v-if="scope.row.order_class=='groups'">团购订单</span>
              <span v-if="scope.row.order_class=='seckill'">秒杀订单</span>
              <span v-if="scope.row.order_class=='community'">社区订单</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="处方审核" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" v-if="scope.row.prescription_review == 0 && scope.row.order_drug == 1">待审核</el-tag >
              <el-tag type="success" size="mini" v-if="scope.row.prescription_review == 1 && scope.row.order_drug == 1">已通过</el-tag>
              <el-tag type="danger" size="mini" v-if="scope.row.prescription_review == 2 && scope.row.order_drug == 1">未通过</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column label="处方审核" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" v-if="scope.row.prescription_order_status == 0 && scope.row.order_drug == 1">待审核</el-tag>
              <el-tag type="success" size="mini" v-if="scope.row.prescription_order_status == 1 && scope.row.order_drug == 1">已通过</el-tag>
              <el-tag type="danger" size="mini" v-if="scope.row.prescription_order_status == 2 && scope.row.order_drug == 1">未通过</el-tag>
            </template>
          </el-table-column>
          <!--
          <el-table-column prop="is_distribution" label="是否分销">
            <template slot-scope="scope">
              <span v-if="scope.row.is_distribution == 1"> 是 </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          -->
          <el-table-column prop="order_status" label="订单状态" width="80" align="center">
            <template slot-scope="scope">
              <!-- 订单状态 -->
              <el-tag v-if="scope.row.order_status == 'PAYED'" type="success" size="mini" style="margin-left: 0">已支付</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'NOTPAY'" size="mini" style="margin-left: 0">未支付</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'CANCEL'" type="danger" size="mini" style="margin-left: 0">已取消</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'WAIT_BUYER_CONFIRM' && scope.row.cancel_status == 'NO_APPLY_CANCEL'" type="danger" size="mini" style="margin-left: 0">待收货</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'REFUND_SUCCESS'" type="danger" size="mini" style="margin-left: 0"> 已退款</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'WAIT_GROUPS_SUCCESS'" type="danger" size="mini" style="margin-left: 0"> 等待成团</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'DONE'" type="success" size="mini" style="margin-left: 0">已完成</el-tag>
              <el-tag v-else-if="scope.row.order_status == 'WAIT_BUYER_CONFIRM' && scope.row.cancel_status == 'SUCCESS'" type="danger" size="mini" style="margin-left: 0">售后已处理</el-tag>
              <el-tag v-else type="danger" size="mini" style="margin-left: 0">异常</el-tag>
              <template v-if="scope.row.order_status != 'CANCEL' && scope.row.order_status != 'REFUND_SUCCESS' && scope.row.order_status != 'WAIT_GROUPS_SUCCESS'">
                <!-- 发货状态 -->
                <el-tag v-if="scope.row.delivery_status == 'DONE'" type="success" size="mini" style="margin-left: 0">已发货</el-tag>
                <el-tag v-else-if="scope.row.delivery_status == 'PARTAIL'" type="danger" size="mini" style="margin-left: 0">部分发货</el-tag>
                <el-tag v-else-if="scope.row.cancel_status == 'WAIT_PROCESS'" type="danger" size="mini" style="margin-left: 0"> 取消待退款</el-tag>
                <el-tag v-else-if="scope.row.ziti_status == 'PENDING'" type="danger" size="mini" style="margin-left: 0">待自提</el-tag>
                <el-tag v-else-if="scope.row.ziti_status == 'DONE'" type="danger" size="mini" style="margin-left: 0">已自提</el-tag>
                <el-tag v-else size="mini" style="margin-left: 0">待发货</el-tag>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="push_to_erp_status" label="推送状态" width="95" align="center">
            <template slot-scope="scope">
              <!-- 订单状态 -->
              <el-tag v-if="scope.row.push_to_erp_status == '0'" size="mini">未推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_erp_status == ''" size="mini">未推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_erp_status == null" size="mini">未推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_erp_status == '1'" type="success" size="mini">已推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_erp_status == '2'" type="danger" size="mini">推送失败</el-tag>
              <el-tag v-else-if="scope.row.push_to_erp_status == '3'" type="warning" size="mini">推送中...</el-tag>
              <br>
              <el-tag v-if="scope.row.push_to_youxuan_status == '0'" size="mini">优选未推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_youxuan_status == '11'" size="mini">优选未推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_youxuan_status == '1'" size="mini">优选已推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_youxuan_status== '2'" type="danger" size="mini">优选不推送</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="push_to_saas_status" label="推送三方" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.push_to_saas_status == '0'" size="mini">未推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_saas_status == '1'" type="success" size="mini">已推送</el-tag>
              <el-tag v-else-if="scope.row.push_to_saas_status == '2'" type="danger" size="mini">推送失败</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="pay_type" label="支付类型" width="110" align="center">
            <template slot-scope="scope">
              <!-- 支付类型 -->
              <span v-if="scope.row.pay_type == 'wxpay'">微信支付</span>
              <span v-else-if="scope.row.pay_type == 'wxpaypc'">微信PC支付</span>
              <span v-else-if="scope.row.pay_type == 'wxpayapp'">微信APP支付</span>
              <span v-else-if="scope.row.pay_type == 'alipay'">支付宝支付</span>
              <span v-else-if="scope.row.pay_type == 'alipayapp'">支付宝APP支付</span>
              <span v-else-if="scope.row.pay_type == 'alipayxapp'">支付宝小程序支付</span>
              <span v-else-if="scope.row.pay_type == 'yaoking_deposit'">商城预存款</span>
              <span v-else-if="scope.row.pay_type == 'yibaopay'">省医保</span>
              <span v-else-if="scope.row.pay_type == 'jh_digital'">交行数字快捷支付</span>
              <span v-else-if="scope.row.pay_type == 'jsapi'">微信H5支付</span>
              <span v-else-if="scope.row.pay_type == 'wxpayh5'">微信H5支付</span>
              <span v-else-if="scope.row.pay_type == 'spdb_h5_xppay'">浦发小浦支付</span>
              <span v-else-if="scope.row.pay_type == 'ccb_h5_digital'">建行数字货币支付</span>
              <span v-else-if="scope.row.pay_type == 'SCAN_ALIPAY'">商家支付宝支付</span>
              <span v-else-if="scope.row.pay_type == 'WECHATPAY_MINIPROGRAM'">商家微信小程序支付</span>
              <span v-else-if="scope.row.pay_type =='benefit'">优卡支付</span>
              <span v-else-if="scope.row.pay_type == 'peihepay'">沛合直付</span>
              <span v-else-if="scope.row.pay_type == 'fuioupay_miniprogram'">富友微信小程序支付</span>
              <span v-else-if="scope.row.pay_type == 'corporate_pay'">对公打款</span>
            </template>
          </el-table-column>
            <el-table-column prop="receipt_type" label="配送方式" width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.receipt_type == 'ziti'">自提</span>
              <span v-else-if="scope.row.receipt_type == 'logistics'">及时配送</span>
              <span v-else-if="scope.row.receipt_type == 'express'">快递配送</span>
            </template>
          </el-table-column>
          <el-table-column prop="source_name" label="来源"  width="50"></el-table-column>
          <!-- <el-table-column label="是否服务类" fixed="right">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_settle_in_service == '1'" type="danger" size="mini">服务</el-tag>
              <el-tag v-else-if="scope.row.is_settle_in_service == '0'" type="success" size="mini">普通</el-tag>
            </template>
          </el-table-column> -->
          <!--<el-table-column label="异常订单" fixed="right" width="90">-->
          <!--<template slot-scope="scope">-->
          <!--<el-button type="danger" size="mini" v-if="scope.row.cancel_status == 'WAIT_PROCESS' && (scope.row.order_status == 'PAYED')" @click="handleAbnormal(scope.row.order_id)">处理</el-button>-->
          <!--</template>-->
          <!--</el-table-column>-->
          <!-- <el-table-column label="推送骑手" fixed="right">
            <template slot-scope="scope">
              <template v-if="scope.row.receipt_type == 'logistics'">
                <el-button size="mini" @click="pushOrderMt(scope.row.order_id)" type="success">推送美团</el-button>
                <el-button size="mini" style="margin: 3px 0;"  @click="pushOrderFn(scope.row.order_id)" type="success">推送蜂鸟</el-button>
              </template>
              <template v-else-if="scope.row.receipt_type == 'ziti'">
                <span>自提订单</span>
              </template>
              <template v-else-if="scope.row.receipt_type == 'express'">
                <span>快递订单</span>
              </template>
            </template>
          </el-table-column> -->
          <el-table-column prop="remark" label="管理员备注" >
            <template slot-scope="scope">
              <span v-if="scope.row.admin_remarks">{{scope.row.admin_remarks}}</span>
            </template>
          </el-table-column>
<!--          <el-ta  ble-column prop="source" label="第三方来源" >-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.source">{{scope.row.source}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="docname" label="文章标题" >-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.docname">{{scope.row.docname}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="scope">
              <router-link :to="{ path: matchHidePage('detail'), query: { orderId: scope.row.order_id, resource: $route.path,order_menu_status:params.order_status }}">详情</router-link>
              <el-button type="text" v-if="scope.row.pay_type == 'corporate_pay' && scope.row.order_status == 'NOTPAY' && scope.row.cancel_status == 'NO_APPLY_CANCEL'" @click="corporateAuditAction(scope.row.order_id)" style="margin-left: 0">审核</el-button>
              <el-button type="text" v-if="scope.row.cancel_status=='NO_APPLY_CANCEL' && (scope.row.order_status == 'NOTPAY' || scope.row.order_status == 'PAYED')" @click="cancelOrderAction(scope.row.order_id)">取消订单</el-button>
              <el-button type="text" v-if="scope.row.order_drug =='1'" @click="order_drug_detail(scope.row.order_id)">处方详情</el-button>
              <el-button type="text" v-if="scope.row.order_drug =='1'" @click="updateDrug(scope.row.order_id)">处方更新</el-button>
              <span v-if="!IsBind">
<!--                <el-button type="text" v-if="scope.row.receipt_type=='express' && scope.row.order_status == 'PAYED' && scope.row.delivery_status != 'DONE'" @click="deliveryAction(scope.row.order_id)">发货</el-button>-->
                <el-button type="text" v-if="scope.row.receipt_type=='express' && scope.row.order_status == 'PAYED'" @click="ReDeliveryAction(scope.row)">补录快递单号</el-button>
                <el-button type="text" v-if="scope.row.cancel_status=='WAIT_PROCESS' && scope.row.order_status == 'PAYED'" @click="confirmCancelOrderAction(scope.row.order_id)" style="margin-left: 0">退款</el-button>
                <el-button type="text" v-if="scope.row.cancel_status=='NO_APPLY_CANCEL' && scope.row.order_status == 'PAYED'" @click="confirmDoneOrderAction(scope.row.order_id)"  style="margin-left: 0">完成订单</el-button>
                <el-button type="text" @click="confirmRemarkOrderAction(scope.row.order_id,scope.row.admin_remarks)" style="margin-left: 0">备注</el-button>
                <el-button type="text" v-if="scope.row.cancel_status == 'WAIT_PROCESS' && (scope.row.order_status == 'PAYED')" @click="handleAbnormal(scope.row.order_id)" style="margin-left: 0">修改订单为已取消</el-button>
                 <el-button type="text" v-if="scope.row.delivery_status == 'DONE' && (scope.row.push_to_erp_status == '1')" @click="refundGoods(scope.row.order_id)" style="margin-left: 0">申请售后</el-button>
              </span>
              <!-- <template v-if="scope.row.receipt_type == 'logistics'">
                <el-button type="text" @click="pushOrderMt(scope.row.order_id)">推送美团</el-button>
                <el-button type="text" style="margin: 3px 0;"  @click="pushOrderFn(scope.row.order_id)">推送蜂鸟</el-button>
                <el-button type="text" style="margin: 3px 0;"  @click="pushOrderPt(scope.row.order_id)">推送跑腿</el-button>
                <el-button type="text" style="margin: 3px 0;"  @click="getOmsSendOrderLocationInfo(scope.row.order_id)">查看骑手轨迹</el-button>
              </template> -->
              <!-- <template v-if="
              scope.row.receipt_type == 'express' &&
              scope.row.cancel_status == 'NO_APPLY_CANCEL' &&
              scope.row.order_status != 'NOTPAY' &&
              scope.row.order_status != 'CANCEL'
              ">
                <el-button type="text" @click="pushExpressOrder2Oms(scope.row.order_id)">重新推送OMS发快递</el-button>
              </template> -->

              <span v-if="
              scope.row.delivery_status != 'DONE'
              && scope.row.ziti_status != 'DONE'
              && scope.row.order_status != 'CANCEL'
              && scope.row.push_to_erp_status != '1'
              && scope.row.cancel_status  == 'NO_APPLY_CANCEL'
              && scope.row.order_status != 'NOTPAY'
              && scope.row.is_allinpay != '1'
              ">
                <el-button @click="pushOrder(scope.row.order_id)" type="text">手动推送</el-button>
              </span>
              <span v-if="scope.row.push_to_youxuan_status == 11 && scope.row.push_to_erp_status==1">
                <el-button @click="pushYxOrder(scope.row.order_id)" type="text">推送优选</el-button>
              </span>
              <span v-if="scope.row.admin_remarks && scope.row.admin_remarks.indexOf('cjy_orderid') !== -1 && (scope.row.order_status != 'NOTPAY' && scope.row.order_status != 'CANCEL')">
                <el-button @click="pushMemCenter(scope.row.order_id)" type="text">补推会员中台</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[10,20,50]"
                  :total="total_count"
                  :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>

      <!-- 发货-开始 -->
      <el-dialog :title="deliveryTitle" :visible.sync="deliveryVisible"  :before-close="handleCancel" width="57%">
        <template>
          <el-form ref="deliveryForm" :model="deliveryForm" class="demo-ruleForm" label-width="100px">
            <el-form-item label="订单号">
              <el-col :span="20">{{deliveryData.orderInfo.order_id}}</el-col>
            </el-form-item>
            <el-form-item label="发货类型">
              <el-radio-group :disabled="IsDisabled" v-model="deliveryForm.delivery_type">
                <el-radio label="batch">整单发货</el-radio>
                <el-radio label="sep">拆分发货</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="商品信息">
              <el-col :span="30">
                <el-table
                        :data="deliveryData.orderInfo.items"
                        style="width: 100%">
                  <el-table-column
                          prop="item_name"
                          label="商品名"
                          width="180">
                  </el-table-column>
                  <el-table-column
                          prop="num"
                          label="数量"
                          width="180">
                  </el-table-column>
                  <el-table-column  label="总价(元)">
                    <template slot-scope="scope">
                      <span>{{scope.row.fee_symbol}}{{scope.row.total_fee / 100}}</span>
                    </template>
                  </el-table-column>
                  <template v-if="deliveryForm.delivery_type == 'sep'">
                    <el-table-column  label="快递公司" width="200">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.delivery_corp" filterable placeholder="请选择快递公司，可搜索">
                          <el-option
                                  v-for="item in dlycorps"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.value">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column  label="物流单号" width="200">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.delivery_code" :maxlength=20 placeholder="物流公司单号"></el-input>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </el-col>
            </el-form-item>
            <template v-if="deliveryForm.delivery_type == 'batch'">
              <el-form-item  label="快递公司">
                <el-col>
                  <el-select v-model="deliveryForm.delivery_corp" filterable placeholder="请选择快递公司，可搜索">
                    <el-option
                            v-for="item in dlycorps"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="物流单号">
                <el-col :span="14"><el-input v-model="deliveryForm.delivery_code" :maxlength=20 placeholder="物流公司单号"></el-input></el-col>
              </el-form-item>
            </template>
          </el-form>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="handleCancel">取消</el-button>
          <el-button type="primary" @click="submitDeliveryAction">确定</el-button>
        </div>
      </el-dialog>
      <!-- 订单补发-开始 -->
      <el-dialog :title="ReDeliveryTitle" :visible.sync="ReDeliveryVisible"  :before-close="handleCancel" width="57%">
        <template>
          <el-form ref="ReDeliveryForm" :model="ReDeliveryForm" class="demo-ruleForm" label-width="100px">
            <el-form-item label="订单号">
              <el-col :span="20">{{ReDeliveryData.orderInfo.order_id}}</el-col>
            </el-form-item>
            <template>
<!--              <el-form-item  label="快递公司">-->
<!--                <el-col>-->
<!--                  <el-select v-model="ReDeliveryForm.delivery_corp" :disabled="reDeliveryIsDisabled" filterable placeholder="请选择快递公司，可搜索">-->
<!--                    <el-option-->
<!--                      v-for="item in dlycorps"-->
<!--                      :key="item.value"-->
<!--                      :label="item.name"-->
<!--                      :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-col>-->
<!--              </el-form-item>-->
              <el-form-item label="快递公司">
                <el-col :span="14"><el-input v-model="ReDeliveryForm.delivery_corp" :maxlength=20 placeholder="请输入快递公司"></el-input></el-col>
              </el-form-item>
              <el-form-item label="物流单号">
                <el-col :span="14"><el-input v-model="ReDeliveryForm.delivery_code" :maxlength=20 placeholder="物流公司单号"></el-input></el-col>
              </el-form-item>
              <el-form-item  label="发货时间" width="200">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="ReDeliveryForm.reDeliveryTime"
                    type="datetime"
                    value-format="timestamp"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </template>
              </el-form-item>
            </template>
          </el-form>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="handleCancel">取消</el-button>
          <el-button type="primary" @click="submitReDeliveryAction">确定</el-button>
        </div>
      </el-dialog>
      <!-- 取消订单退款审核-开始 -->
      <el-dialog title="取消订单退款审核" :visible.sync="cancelVisible" :before-close="handleCancelOrderCancel" width="57%">
        <template>
          <el-row :gutter="100">
            <el-col :span="24">
              <span class="grid-content">订单号:{{cancelData.order_id}}</span>
            </el-col>
            <el-col :span="24">
              <span v-if="cancelData.cancel_from=='buyer'">取消来源:消费者申请</span>
              <span v-else>取消来源:系统自动取消</span>
            </el-col>
            <el-col :span="24">
              <span>申请时间:{{cancelData.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
            </el-col>
            <el-col :span="24">
              <span>退款状态:</span>
              <span v-if="cancelData.refund_status=='WAIT_CHECK'">待审核</span>
              <span v-if="cancelData.refund_status=='FAILS'">退款失败</span>
              <span v-if="cancelData.refund_status=='SUCCESS'">退款成功</span>
              <span v-if="cancelData.refund_status=='SHOP_CHECK_FAILS'">商家审核不通过</span>
              <span v-if="cancelData.refund_status=='WAIT_REFUND'">等待退款</span>
            </el-col>
            <el-col :span="24">
              <span>处理进度:</span>
              <span v-if="cancelData.progress=='0'">待处理</span>
              <span v-if="cancelData.progress=='1'">已取消</span>
              <span v-if="cancelData.progress=='2'">退款中</span>
              <span v-if="cancelData.progress=='3'">已完成</span>
            </el-col>
            <el-col :span="24">
              <span>退款金额:{{cancelData.fee_symbol}}{{cancelData.total_fee/100}}</span>
            </el-col>
            <el-col :span="24">
              <span v-if="cancelData.pay_type=='wxpay'">支付方式:微信支付</span>
            </el-col>
            <el-col :span="24">
              <span>取消原因:{{cancelData.cancel_reason}}</span>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-form ref="cancelForm" :model="cancelForm" class="" label-width="100px">
            <el-form-item label="处理结果:">
              <el-row>
                <el-col :span="20">
                  <template>
                    <el-radio v-model="cancelForm.check_cancel" label="0">不同意</el-radio>
                    <el-radio v-model="cancelForm.check_cancel" label="1">同意</el-radio>
                  </template>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="拒绝原因:"  v-if="cancelForm.check_cancel=='0'">
              <el-row>
                <el-col :span="24">
                  <el-input type="textarea" v-model="cancelForm.shop_reject_reason" :rows="3" placeholder="请输入拒绝原因"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="handleCancelOrderCancel">取消</el-button>
          <el-button type="primary" @click="submitCancelConfirmAction">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="取消订单退款审核备注" :visible.sync="remarkVisible" :before-close="handleRemarkOrderCancel" width="57%">
        <template>
          <el-row :gutter="100">
            <el-col :span="24">
              <el-input placeholder="输入退款审核备注" v-model="remarkData.admin_remarks" clearable class="input-with-select"></el-input>
            </el-col>
          </el-row>

        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="handleRemarkOrderCancel">取消</el-button>
          <el-button type="primary" @click="submitRemarkConfirmAction">确定</el-button>
        </div>
      </el-dialog>
      <!--处方详情-->
      <el-dialog title="处方详情" :visible.sync="drugVisible" :before-close="handleordersdrug" width="57%">
        <template>
          <el-row style="border-bottom: 1px solid #dcdfe6">
            <el-col :span="3" class="content-left"><h4>NO：</h4></el-col>
            <el-col :span="7"> {{orderDrugInfo.id}} </el-col>
            <el-col :span="3" class="content-left"><h4>处方日期：</h4></el-col>
            <el-col :span="7"> {{orderDrugInfo.open_time}} </el-col>
          </el-row>
          <el-row style="border-bottom: 1px solid #dcdfe6" v-if="orderDrugInfo.pres_type == '图文咨询' || orderDrugInfo.pres_type == 'userimgcheck'">
            <el-col :span="7" v-for="(item, index) in orderDrugInfo.prescription_img" :key="index">
              <img :src="item" alt="" style="width:70%;height:70%" @click="clickImg(index)">
            </el-col>
          </el-row>
          <el-row style="border-bottom: 1px solid #dcdfe6">
            <el-col :span="3" class="content-left"><h4>姓名：</h4></el-col>
            <el-col :span="5"> {{orderDrugInfo.patient_name}}</el-col>
            <el-col :span="3" class="content-left"><h4>性别：</h4></el-col>
            <el-col :span="5"> {{orderDrugInfo.member_sex}} </el-col>
            <el-col :span="3" class="content-left"><h4>年龄：</h4></el-col>
            <el-col :span="5">{{orderDrugInfo.member_age}}</el-col>
          </el-row>
          <el-row style="border-bottom: 1px solid #dcdfe6">
            <el-col :span="3" class="content-left"><h4>诊断：</h4></el-col>
            <el-col :span="5"> {{orderDrugInfo.diagnose_result}}</el-col>
          </el-row>
          <el-row></el-row>
          <el-row v-for="(item, index) in yaopinInfo" :key="index" style="border-bottom: 1px solid #dcdfe6">
            <el-col :span="5" class="content-left">
              <span >{{index+1}}：{{item.name}}</span>
            </el-col>
            <el-col :span="8"  class="content-left">
              <span >{{item.drug_spec}}</span>
            </el-col>
            <el-col :span="8"  class="content-left">
              <span >{{item.nums}}{{item.drug_unit}}</span>
            </el-col>
            <el-row>
              <el-col :span="8"  class="content-left">
                <span >用法用量：{{item.frequencies}}次/{{item.days}}天，每次{{item.amounts}}</span>
              </el-col>
              <el-col :span="8"  class="content-left">
                <span>其他：{{item.directions}}</span>
              </el-col>
            </el-row>
          </el-row>
          <el-row></el-row>
          <el-row>
            <el-col :span="3" class="content-left"><h4>诊断医师：</h4></el-col>
            <el-col :span="7"> {{orderDrugInfo.opener_name}} </el-col>
            <el-col :span="3" class="content-left"><h4>审核药师：</h4></el-col>
            <el-col :span="7"> {{orderDrugInfo.auditor_name}} </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" class="content-left"><h4>处方医师：</h4></el-col>
            <el-col :span="7"></el-col>
            <el-col :span="5" class="content-left"><h4>调剂：</h4></el-col>
            <el-col :span="5"></el-col>
            <el-col :span="5" class="content-right"><h4>复核：</h4></el-col>
            <el-col :span="5"></el-col>
          </el-row>
          <el-row class="content-center">
            <h2>所购药品</h2>
          </el-row>
          <el-row v-for="(item, index) in yaopinInfo" :key="index" style="border-bottom: 1px solid #dcdfe6">
            <el-row>
              <el-col :span="3" class="content-left"><h4>药品名称：</h4></el-col>
              <el-col :span="7"> {{item.name}}</el-col>
              <el-col :span="3" class="content-left"><h4>购买数量：</h4></el-col>
              <el-col :span="5">{{item.nums}}</el-col>
            </el-row>
          </el-row>
          <el-row>
            <el-col :span="5" class="content-left"><span>处方审核状态：</span></el-col>
            <el-col :span="7">{{orderDrugInfo.zhuangtai}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="content-left"><span>处方审核不通过原因：</span></el-col>
            <el-col :span="7" v-if="orderDrugInfo.invalid =='true'">
              <span>{{orderDrugInfo.invalid_reason}}{{orderDrugInfo.cb_reason}}</span>
            </el-col>
            <el-col :span="5" v-if="orderDrugInfo.invalid =='false'">
              <span v-if="orderDrugInfo.open_status ==2 && orderDrugInfo.status == 0 ">{{orderDrugInfo.refuse_case}}</span>
              <span v-else-if="orderDrugInfo.open_status ==1 && orderDrugInfo.status == 0">等待药师审核</span>
              <span v-else-if="orderDrugInfo.open_status ==1 && orderDrugInfo.status == 2">{{orderDrugInfo.cb_reason}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="content-left"><span>订单审核不通过原因：</span></el-col>
            <el-col :span="7" v-if="orderData.prescription_order_status == '2'">
              <span>{{orderData.prescription_order_deny_reason}}</span>
            </el-col>
          </el-row>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="handleordersdrug">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="处方详情" :visible.sync="imgVisible" :before-close="imgClose"  width="57%">
        <template>
          <el-row style="width:50%;height: 30%;text-align:center">
            <img :src="imgSrc" alt="" class="image-item" style="width:100%;height: 40%;">
          </el-row>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="imgClose">确定</el-button>
        </div>
      </el-dialog>
      <!-- 对公打款审核 -->
      <el-dialog title="对公打款审核" :visible.sync="corporateAuditVisible" :before-close="handleCorporateAuditCancel" width="57%">
        <template>
          <el-row :gutter="20">
            <el-col :span="24">
              <span>订单号：{{ corporateAuditData.orderInfo.order_id }}</span>
            </el-col>
            <el-col :span="24">
              <span>下单时间：{{ corporateAuditData.orderInfo.create_time | datetime('yyyy-MM-dd hh:mm:ss') }}</span>
            </el-col>
            <el-col :span="24">
              <span>订单金额：{{ corporateAuditData.orderInfo.fee_symbol }}{{ corporateAuditData.orderInfo.total_fee / 100 }}</span>
            </el-col>
            <el-col :span="24">
              <span>支付方式：对公打款</span>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-form ref="corporateAuditFormRef" :model="corporateAuditForm" label-width="120px">
            <el-form-item label="审核结果：">
              <el-radio-group v-model="corporateAuditForm.audit_result" @change="handleCorporateAuditResultChange">
                <el-radio label="1">审核通过</el-radio>
                <el-radio label="0">审核不通过</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="corporateAuditForm.audit_result == '1'" label="交易流水号：">
              <el-input
                v-model="corporateAuditForm.transaction_id"
                maxlength="64"
                placeholder="请输入银行交易流水号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item v-if="corporateAuditForm.audit_result == '0'" label="不通过原因：">
              <el-input
                v-model="corporateAuditForm.reject_reason"
                type="textarea"
                :rows="3"
                resize="none"
                placeholder="请填写审核不通过原因"
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="handleCorporateAuditCancel">取消</el-button>
          <el-button type="primary" :loading="corporateAuditSubmitting" @click="submitCorporateAuditAction">确定</el-button>
        </div>
      </el-dialog>
      <!-- 取消订单 -->
      <el-dialog title="取消订单" :visible.sync="cancelOrderVisible" :before-close="handleCancelOrder" width="57%">
        <template>
          <el-form ref="cancelForm" :model="cancelOrderForm" class="" label-width="100px">
            <el-form-item label="订单号:">
              <el-col :span="20">{{cancelOrderData.orderInfo.order_id}}</el-col>
            </el-form-item>
            <el-form-item label="取消原因:">
              <el-row>
                <el-col :span="20">
                  <template>
                    <el-select v-model="cancel_order" filterable placeholder="请选择取消订单原因" @change="cancelReasonSelect">
                      <el-option
                              v-for="item in order_cancel_reason"
                              :key="item.value"
                              :label="item.name"
                              :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input v-show="cancelOrderInput" v-model="cancelOrderForm.other_reason" type="textarea" :rows="3" resize="none"  style="width: 200px; margin-top: 10px" placeholder="请填写取消订单原因"></el-input>
                  </template>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="handleCancelOrder">取消</el-button>
          <el-button type="primary" @click="submitCancelOrderConfirmAction">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {
      getOrderList,
      getOrderDetail,
      getOrderDrugDetail,
      handleAb,
      pushOrder,
      refundGoods,
      pushOrderMt,
      pushOrderFn,
      pushOrderPt,
      pushOrderYx,
      pushOrderToMemCenter,
      delivery,
      orderExport,
      getCancelOrderInfo,
      getDoneOrderInfo,
      cancelConfirm,
      addRemarkConfirm,
      getLogisticsList,
      cancelOrderConfirm,
      confirmCorporatePay,
      rejectCorporatePay,
      isBind,
      redelivery,
      getOmsSendOrderLocation,
      pushExpressOrder2Oms,
      updatePreOrder
    } from '../../../../api/trade'
    import { getSourcesList } from '../../../../api/datacube'
    import shopSelect from '@/components/shopSelect'
    import store from '@/store'
    import moment from 'moment'

    export default {
        components: {
            shopSelect,
        },
        data () {
            const defaultCreateTime = this.getDefaultCreateTime()
            return {
               receiptType:[
                {name:'快递',value:'express',},
                {name:'自提',value:'ziti',},
                {name:'及时配送',value:'logistics',},
              ],
               receipt_type:'',
                push_to_youxuan_status:'',
                remarkData:{
                    order_id:'',
                    admin_remarks:''
                },
                IsDisabled: false,
                IsBind: false,
                activeName: 'all',
                loading: false,
                create_time: defaultCreateTime,
                params: {
                    page: 1,
                    pageSize: 20,
                    order_class_exclude: 'drug',
                    order_status:''
                },
                order_class_array: [
                    {name: '全部订单', value: ''},
                    {name: '团购订单', value: 'groups'},
                    {name: '秒杀订单', value: 'seckill'},
                    {name: '社区订单', value: 'community'},
                    {name: '处方订单', value: 'order_drug'}
                ],

              order_third_array:[
                {name:"全部",value:''},
                {name:'复诊卡',value:'fzk'},
                {name:'在线购药',value:'zxgy'},
                ],
                cancelOrderInput: false,
                order_cancel_reason: [
                    {name: '客户现在不想购买', value: 1},
                    {name: '客户商品价格较贵', value: 2},
                    {name: '客户价格波动', value: 3},
                    {name: '客户商品缺货', value: 4},
                    {name: '客户重复下单', value: 5},
                    {name: '客户订单商品选择有误', value: 6},
                    {name: '客户支付方式选择有误', value: 7},
                    {name: '客户收货信息填写有误', value: 8},
                    {name: '客户发票信息填写有误', value: 9},
                    {name: '客户无法支付订单', value: 10},
                    {name: '客户长时间未付款', value: 11},
                    {name: '客户其他原因', value: 12}
                ],
                merchantType: [
                  {name: '全部订单', value: ''},
                  {name: '怡康自营订单', value: 'self'},
                  {name: '第三方商家订单', value: 'third'},
                ],
                sourceType: [
                  {name: '全部来源订单', value: ''},
                  {name: '怡康自营', value: '2'},
                  {name: '怡康优选', value: '1'},
                ],
                pay_type_array: [
                  {name: '全部类型', value: ''},
                  {name: '微信支付', value: 'wxpay'},
                  {name: '微信PC支付', value: 'wxpaypc'},
                  {name: '微信APP支付', value: 'wxpayapp'},
                  {name: '支付宝支付', value: 'alipay'},
                  {name: '支付宝APP支付', value: 'alipayapp'},
                  {name: '支付宝小程序支付', value: 'alipayxapp'},
                  {name: '商城预存款', value: 'yaoking_deposit'},
                  {name: '省医保', value: 'yibaopay'},
                  {name: '交行数字快捷支付', value: 'jh_digital'},
                  {name: '浦发小浦支付', value: 'spdb_h5_xppay'},
                  {name: '建行数字货币支付', value: 'ccb_h5_digital'},
                  {name: '沛合直付', value: 'peihepay'},
                  {name: '富友微信小程序支付', value: 'fuioupay_miniprogram'},
                  {name: '对公打款', value: 'corporate_pay'},
                ],
                order_status: '',
                imgSrc:'',
                salesman_mobile: '',
                total_count: 0,
                order_type: 'normal',
                list: [],
                identifier: '',
                item_bn: '',
                source_list: [],
                orderDrugInfo:[],
                yaopinInfo:[],
                orderData:[],
                source_name: '',
                source_id: '',
                order_class: '',
                source:'',
                pay_type:'',
                merchant_type:'',
                cancel_order: '',
                deliveryVisible: false,
                deliveryTitle: '',
                deliveryData: {
                    orderInfo: {}
                },
                deliveryForm: {
                    delivery_type: 'batch',
                    order_id: '',
                    delivery_corp: '',
                    delivery_code: '',
                    sepInfo: {}
                },
                ReDeliveryVisible:false,
                reDeliveryIsDisabled:false,
                ReDeliveryTitle:'',
                ReDeliveryData:{
                    orderInfo: {}
                },
                ReDeliveryForm: {
                  order_id: '',
                  delivery_corp: '',
                  delivery_code: '',
                  merchant_id: '',
                  DeliveryTime: '',
                  reDeliveryTime: ''
                },
                dlycorps: [],
                cancelVisible: false,
                remarkVisible: false,
                drugVisible: false,
                imgVisible: false,
                cancelData: {
                    orderInfo: {}
                },
                cancelForm: {
                    order_id: '',
                    check_cancel: '1',
                    shop_reject_reason: ''
                },
                cancelOrderVisible: false,
                cancelOrderData: {
                    orderInfo: {}
                },
                cancelOrderForm: {
                    order_id: '',
                    cancel_reason: 0,
                    other_reason: ''
                },
                corporateAuditVisible: false,
                corporateAuditSubmitting: false,
                corporateAuditData: {
                    orderInfo: {}
                },
                corporateAuditForm: {
                    order_id: '',
                    audit_result: '1',
                    transaction_id: '',
                    reject_reason: ''
                },
                downloadView: false,
                downloadUrl: '',
                downloadName: '',
                queryData: {
                    UserName: "",
                    CustomerCode: "",
                    CustomerName: "",
                    role: 0,
                    p_Role: "",
                    prop : "",
                    order : "",
                    currentPage: 1,
                    pageSize: 10
                },
            }
            omslocation:''
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
          getDefaultCreateTime() {
            const range = this.getLastThreeMonthsRange()
            return [
              this.formatDateForPicker(range.start),
              this.formatDateForPicker(range.end)
            ]
          },
          formatDateForPicker(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}/${m}/${d}`
          },
          // 获取最近一年的起止时间（含当前月）
          getLastThreeMonthsRange() {
            const now = new Date();
            let currentYear = now.getFullYear();
            let currentMonth = now.getMonth();
            // 计算一年前的月份
            let startMonth = currentMonth - 11;
            let startYear = currentYear;
            if (startMonth < 0) {
              startMonth += 12;
              startYear -= 1;
            }
            // 开始时间：一年前的1号 00:00:00
            const start = new Date(startYear, startMonth, 1);
            // 结束时间：当前月最后一天 23:59:59.999
            const end = new Date(currentYear, currentMonth + 1, 0, 23, 59, 59, 999);
            return { start, end };
          },
          getOmsSendOrderLocationInfo(order_id){
              getOmsSendOrderLocation({order_id:order_id}).then(res=>{
                  this.omslocation = res.data.data;
                   this.$alert(JSON.stringify(this.omslocation), {
                            dangerouslyUseHTMLString: true
                   });
              })
           },
           receiptTypeChange(){
                this.params.page = 1
                this.params.receipt_type=this.receipt_type;
                this.getParams()
                this.getOrders(this.params)
           },
            sortChange(column,prop,order){
                if(column.prop == null || column.order == null){
                    this.params.prop = "";
                    this.params.order_sort = "";
                }else{
                    this.params.prop = column.prop;
                    this.params.order_sort = column.order;
                }
                this.getList(column);
            },
            clickImg(index){
                this.imgVisible = true;
                let images = JSON.parse(JSON.stringify(this.orderDrugInfo.prescription_img))
                for(let i=0;i<index;i++){
                    images.push(images[0]);
                    images.splice(0,1);
                }
                this.imgSrc = images
            },
            getList(column) {
                this.loading = true;
                this.getParams()
                getOrderList(this.params).then(response => {
                    this.list = response.data.data.list
                    this.total_count = Number(response.data.data.pager.count)
                    this.loading = false
                    this.prop = column.prop;
                    this.order_sort = column.order;
                })
            },
            // 切换tab
            handleClick(tab, event) {
                this.activeName = tab.name
                this.params.order_status = tab.name == 'all' ? '' : tab.name
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
                if (tab.name != 'cancelapply') {
                    this.params.prop = "";
                    this.params.order_sort = "";
                }
            },
            storeSearch (val) {
                val && val.shop_id
                this.params.distributor_id = val.shop_id
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            TypeHandle (val) {
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            sourceChange (val) {
                this.params.page = 1
                this.params.push_to_youxuan_status=this.push_to_youxuan_status;
                this.getParams()
                this.getOrders(this.params)
            },
            numberSearch (e) {
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            itemBnSearch (e) {
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            dateChange () {
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            sourceSearch(item) {
                this.params.source_id = item.source_id
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            handleCurrentChange (page_num) {
                this.loading = false
                this.params.page = page_num
                this.getParams()
                this.getOrders(this.params)
            },
            handleSizeChange (pageSize) {
                this.loading = false
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getParams()
                this.getOrders(this.params)
            },
            TypePayHandle (val) {
                this.params.page = 1
                this.getParams()
                this.getOrders(this.params)
            },
            getParams () {
                if (this.create_time && this.create_time.length === 2) {
                    this.params.time_start_begin = this.dateStrToTimeStamp(this.create_time[0] + ' 00:00:00')
                    this.params.time_start_end = this.dateStrToTimeStamp(this.create_time[1] + ' 23:59:59')
                } else {
                    this.params.time_start_begin = ''
                    this.params.time_start_end = ''
                }
                this.params.order_type = this.order_type
                this.params.order_class = this.order_class
                this.params.source=this.source
                this.params.pay_type = this.pay_type
                this.params.merchant_type = this.merchant_type
                this.params.salesman_mobile = this.salesman_mobile
                this.params.item_bn = this.item_bn
                this.identifier=this.identifier.replace( /^\s*/, '');
                this.identifier=this.identifier.replace(/(\s*$)/g, "");
                if(this.identifier.length == 11) {
                    this.params.mobile = this.identifier
                    this.params.order_id = ''
                } else {
                    this.params.mobile = ''
                    this.params.order_id = this.identifier
                }
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            getTaskTime (strDate) {
              let date = new Date(strDate)
              let y = date.getFullYear()
              let m = date.getMonth() + 1
              m = m < 10 ? ('0' + m) : m
              let d = date.getDate()
              d = d < 10 ? ('0' + d) : d
              let h = date.getHours()
              let i = date.getMinutes()
              let s = date.getSeconds()
              let str = y+"-"+m+"-"+d+" "+h+":"+i+":"+s
              return str
            },
            getOrders(filter) {
                this.loading = true
                getOrderList(filter).then(response => {
                    this.list = response.data.data.list
                    this.total_count = Number(response.data.data.pager.count)
                    this.loading = false
                })
            },
            getStatus () {
                isBind().then(response => {
                    this.IsBind = response.data.data.result
                })
            },
            getAllSourcesList () {
                let params = {page: 1, pageSize: 1000}
                getSourcesList(params).then(response => {
                    if(response.data.data.list) {
                        response.data.data.list.forEach(row => {
                            this.source_list.push({'value': row.sourceName, 'source_id': row.sourceId})
                        })
                    }
                })
            },
            querySearch(queryString, cb) {
                var restaurants = this.source_list;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                }
            },
            deliveryAction (order_id) { // 编辑物料弹框
                this.deliveryTitle = '发货'
                getLogisticsList().then(res => {
                    this.dlycorps = res.data.data.list
                })
                getOrderDetail(order_id).then(response => {
                    this.deliveryData = response.data.data
                    if (this.deliveryData.orderInfo.cancel_status == 'WAIT_PROCESS') {
                        this.$message.error('客户已经申请退款，请先处理退款操作再决定是否发货!')
                        return false
                    }
                    this.deliveryVisible = true
                    if (this.deliveryData && this.deliveryData.orderInfo.delivery_status == 'PARTAIL') {
                        this.IsDisabled = true
                        this.deliveryForm.delivery_type = 'sep'
                    }
                })
                this.deliveryForm.order_id = order_id
            },
            ReDeliveryAction (row) {
                this.ReDeliveryTitle = '补录快递单号'
                // this.reDeliveryIsDisabled = true
                getLogisticsList().then(res => {
                  this.dlycorps = res.data.data.list
                })
                getOrderDetail(row.order_id).then(response => {
                  this.ReDeliveryData = response.data.data
                  if (this.ReDeliveryData.orderInfo.cancel_status == 'WAIT_PROCESS') {
                    this.$message.error('客户已经申请退款，请先处理退款操作再决定是否发货!')
                    return false
                  }
                  this.ReDeliveryVisible = true
                });
                this.ReDeliveryForm.order_id = row.order_id
                this.ReDeliveryForm.merchant_id = row.merchant_id
                // if (row.delivery_corp == "") {
                //   this.reDeliveryIsDisabled = false
                //   this.ReDeliveryForm.reDeliveryTime = new Date()
                // } else {
                  this.ReDeliveryForm.delivery_code = row.delivery_code
                  this.ReDeliveryForm.reDeliveryTime = row.delivery_time*1000
                // }
            },
            confirmCancelOrderAction (order_id) { // 已支付订单的取消订单审核
                let params = {order_type:'normal'}
                getCancelOrderInfo(order_id, params).then(response => {
                    this.cancelData = response.data.data
                    this.cancelVisible = true
                    console.log(response)
                })
                this.cancelForm.order_id = order_id
            },
            confirmRemarkOrderAction(order_id,admin_remarks){//取消待审核订单添加备注
                this.remarkData.order_id = order_id;
                this.remarkData.admin_remarks = admin_remarks;
                this.remarkVisible = true
            },
            confirmDoneOrderAction (order_id) {
                this.$confirm('是否要确认收货并完成此订单', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {order_id:order_id}
                    getDoneOrderInfo(params).then(response => {
                        this.doneData = response.data.data
                        console.log(this.doneData);
                        if (this.doneData) {
                            this.$message.success('订单已完成!')
                            return false
                        }else{
                            this.$message.error(response.data.error.message)
                            return false
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            handleAbnormal(order_id) {
                this.$confirm('是否要修改订单状态为已取消？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let params = {order_type:'normal'}
                  handleAb(order_id).then(response => {
                      var status = response.data.data.status
                      if (status == true) {
                          this.$message.success('处理成功')
                          return false
                      }else{
                          this.$message.error('处理失败')
                          return false
                      }
                  })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            refundGoods(order_id){
              this.$confirm('是否要对订单发起售后(退货)申请？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                refundGoods(order_id).then(response => {
                  this.refundData = response.data.data
                  console.log(this.refundData);
                  if (this.refundData.aftersales_bn) {
                    this.$message.success('售后申请成功，请去售后列表进行处理!')
                  } else {
                    this.$message.error('售后申请失败，请联系技术人员处理!')
                    return false
                  }
                })
                this.cancelOrderForm.order_id = order_id
              }).catch(() => {
                  this.$message({
                      type: 'info',
                      message: '已取消操作'
                  });
              });
            },
            pushOrder(order_id){
              // 手动推送订单到 OMS 中台
              this.$confirm('确认要将订单手动推送到 OMS 中台？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                console.log(order_id);
                pushOrder(order_id).then(response => {
                    this.pushData = response.data.data
                    console.log(this.pushData);
                    if (this.pushData.status == 1) {
                        this.$message.success('订单推送成功!')
                    }else{
                        this.$message.error('订单推送失败!')
                        return false
                    }
                })
                this.cancelOrderForm.order_id = order_id
              }).catch(() => {
                  this.$message({
                      type: 'info',
                      message: '已取消操作'
                  });
              });
            },
            pushYxOrder(order_id){
              pushOrderYx(order_id).then(response => {
                this.pushData = response.data.data
                console.log(this.pushData);
                if (this.pushData.status == 1) {
                  this.$message.success('订单推送成功!')
                }else{
                  this.$message.error('订单推送失败!')
                  return false
                }
              })
              this.cancelOrderForm.order_id = order_id
            },
            pushMemCenter(order_id) {
              this.$confirm('确定要将该付费会员订单补推到会员中台吗？', '补推会员中台', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                pushOrderToMemCenter(order_id).then(response => {
                  const data = response.data.data || response.data
                  if (data && data.status) {
                    this.$message.success(data.msg || '补推成功')
                    this.getOrders(this.params)
                  } else {
                    this.$message.error(data.msg || '补推失败')
                  }
                }).catch(err => {
                  const msg = err.response && err.response.data && (err.response.data.message || err.response.data.msg) ? (err.response.data.message || err.response.data.msg) : '补推失败'
                  this.$message.error(msg)
                })
              }).catch(() => {})
            },
            pushExpressOrder2Oms(order_id) {
              pushExpressOrder2Oms(order_id).then(response => {
                this.pushData = response.data
                if (this.pushData.status == true) {
                    this.$message.success('操作成功!')
                    return false
                }else{
                    this.$message.success('操作失败!')
                    return false
                }
              })
            },
            pushOrderMt(order_id){
                // console.log(order_id);
                pushOrderMt(order_id).then(response => {
                    this.pushData = response.data.data
                    console.log(this.pushData);
                    if (this.pushData.msg == 'true') {
                        this.$message.success('操作成功!')
                        return false
                    }else{
                        this.$message.success('操作失败!')
                        return false
                    }
                })
                this.cancelOrderForm.order_id = order_id
            },
            pushOrderFn(order_id){
                // console.log(order_id);
                pushOrderFn(order_id).then(response => {
                    this.pushData = response.data.data
                    // console.log(this.pushData);
                    if (this.pushData.msg == 'true') {
                        this.$message.success('操作成功!')
                        return false
                    }else{
                        this.$message.success('操作失败!')
                        return false
                    }
                })
                this.cancelOrderForm.order_id = order_id
            },
            pushOrderPt(order_id){
                // console.log(order_id);
                pushOrderPt(order_id).then(response => {
                    this.pushData = response.data.data
                    console.log(this.pushData);
                    if (this.pushData.msg == 'true') {
                        this.$message.success('操作成功!')
                        return false
                    }else{
                        this.$message.success('操作失败!')
                        return false
                    }
                })
                this.cancelOrderForm.order_id = order_id
            },
            handleCancelOrderCancel () {
                this.cancelVisible = false
                this.cancelForm.order_id = ''
                this.cancelForm.shop_reject_reason = ''
            },
            handleRemarkOrderCancel(){
                this.remarkVisible = false
                this.cancelForm.order_id = ''
                this.cancelForm.shop_reject_reason = ''
            },
            //  处方详情关闭
            handleordersdrug(){
                this.drugVisible = false
            },
            // 图片详情关闭
            imgClose(){
                this.imgVisible = false
            },
            submitCancelConfirmAction () { // 提交取消订单审核结果
              // 新增退款确认，防止工作人员重复点击
              this.$confirm('是否要继续操作？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                cancelConfirm(this.cancelForm.order_id, this.cancelForm).then( response => {
                    var cancelOrderStatus = response.data.data.refund_status
                    if( cancelOrderStatus == 'SUCCESS') {
                        this.handleCancelOrderCancel()
                        this.$message.success('审核成功!')
                        this.getOrders(this.params)
                    } else {
                        this.$message.success('驳回成功')
                        this.getOrders(this.params)
                        return false
                    }
                })
              }).catch(() => {
                  this.$message({
                      type: 'info',
                      message: '已取消操作'
                  });
              });
            },
            submitRemarkConfirmAction(){//提交取消待审核订单备注
                if (this.remarkData.admin_remarks == null || this.remarkData.admin_remarks == "") {
                    this.$message.error('请输入备注信息')
                    return false
                }
                var _data = {};
                _data.order_id = this.remarkData.order_id;
                _data.admin_remarks = this.remarkData.admin_remarks;
                addRemarkConfirm(_data).then( response => {
                    var remarkOrderStatus = response.data.data.status
                    if( remarkOrderStatus == true) {
                        this.handleRemarkOrderCancel()
                        this.$message.success('备注操作成功')
                        this.getList(this.params)
                    } else {
                        this.$message.error('备注操作失败')
                        return false
                    }
                })
            },
            handleCancel () {
                this.deliveryVisible = false
                this.deliveryForm.order_id = ''
                this.deliveryForm.delivery_corp = ''
                this.deliveryForm.delivery_code = ''
                this.ReDeliveryVisible = false
                this.ReDeliveryForm.order_id = ''
                this.ReDeliveryForm.delivery_corp = ''
                this.ReDeliveryForm.delivery_code = ''
            },
            submitDeliveryAction () { // 提交物料
                if(this.deliveryForm.delivery_type == 'sep') {
                    this.deliveryForm.sepInfo = JSON.stringify(this.deliveryData.orderInfo.items)
                    this.deliveryForm.delivery_corp = ''
                    this.deliveryForm.delivery_code = ''
                } else {
                    this.deliveryForm.sepInfo = {}
                }
                delivery(this.deliveryForm).then( response => {
                    var deliveryStatus = response.data.data.delivery_status
                    if( deliveryStatus && deliveryStatus != 'PENDING') {
                        this.handleCancel()
                        this.$message.success('发货成功!')
                        this.getOrders(this.params)
                    } else {
                        this.$message.error('发货失败!')
                        return false
                    }
                })
            },
            // 提交物料
            submitReDeliveryAction () {
              this.ReDeliveryForm.DeliveryTime = this.dateStrToTimeStamp(this.ReDeliveryForm.reDeliveryTime)
              redelivery(this.ReDeliveryForm).then(response => {
                var ReDeliveryStatus = response.data.data.status
                if (ReDeliveryStatus) {
                  this.handleCancel()
                  this.$message.success('补录成功!')
                  this.getOrders(this.params)
                } else {
                  this.$message.error('补录失败!')
                  return false
                }
              })
            },
            cancelOrderAction(order_id) { //取消订单
                let params = {order_type:'normal'}
                getOrderDetail(order_id).then(response => {
                    this.cancelOrderData = response.data.data
                    console.log(this.cancelOrderData);
                    if (this.cancelOrderData.orderInfo.cancel_status == 'SUCCESS') {
                        this.$message.error('该订单已取消!')
                        return false
                    }
                    this.cancelOrderVisible = true
                })
                this.cancelOrderForm.order_id = order_id
            },
            corporateAuditAction(order_id) {
                getOrderDetail(order_id).then(response => {
                    this.corporateAuditData = response.data.data
                    if (this.corporateAuditData.orderInfo.order_status != 'NOTPAY') {
                        this.$message.error('该订单不是待支付状态，无法审核')
                        return false
                    }
                    if (this.corporateAuditData.orderInfo.pay_type != 'corporate_pay') {
                        this.$message.error('该订单不是对公打款订单')
                        return false
                    }
                    this.corporateAuditForm.order_id = order_id
                    this.corporateAuditForm.audit_result = '1'
                    this.corporateAuditForm.transaction_id = ''
                    this.corporateAuditForm.reject_reason = ''
                    this.corporateAuditVisible = true
                })
            },
            handleCorporateAuditResultChange() {
                this.corporateAuditForm.transaction_id = ''
                this.corporateAuditForm.reject_reason = ''
            },
            handleCorporateAuditCancel() {
                this.corporateAuditVisible = false
                this.corporateAuditSubmitting = false
                this.corporateAuditForm = {
                    order_id: '',
                    audit_result: '1',
                    transaction_id: '',
                    reject_reason: ''
                }
            },
            submitCorporateAuditAction() {
                const orderId = this.corporateAuditForm.order_id
                if (this.corporateAuditForm.audit_result == '1') {
                    if (!this.corporateAuditForm.transaction_id || !this.corporateAuditForm.transaction_id.trim()) {
                        this.$message.error('请填写交易流水号')
                        return false
                    }
                } else {
                    if (!this.corporateAuditForm.reject_reason || !this.corporateAuditForm.reject_reason.trim()) {
                        this.$message.error('请填写审核不通过原因')
                        return false
                    }
                }

                const confirmText = this.corporateAuditForm.audit_result == '1'
                    ? '确认审核通过并推送 POS 吗？'
                    : '确认审核不通过并取消该订单吗？'

                this.$confirm(confirmText, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.corporateAuditSubmitting = true
                    if (this.corporateAuditForm.audit_result == '1') {
                        confirmCorporatePay(orderId, {
                            transaction_id: this.corporateAuditForm.transaction_id.trim()
                        }).then(response => {
                            this.corporateAuditSubmitting = false
                            const result = response.data.data || {}
                            if (result.status) {
                                const pushMsg = result.push_message || ''
                                this.$message.success('审核通过。' + pushMsg)
                                this.handleCorporateAuditCancel()
                                this.getList(this.params)
                            } else {
                                this.$message.error(result.message || '审核失败')
                            }
                        }).catch(error => {
                            this.corporateAuditSubmitting = false
                            this.$message.error((error.response && error.response.data && error.response.data.message) || '审核失败')
                        })
                    } else {
                        rejectCorporatePay(orderId, {
                            reject_reason: this.corporateAuditForm.reject_reason.trim()
                        }).then(response => {
                            this.corporateAuditSubmitting = false
                            const result = response.data.data || {}
                            if (result.status) {
                                this.$message.success(result.message || '审核不通过，订单已取消')
                                this.handleCorporateAuditCancel()
                                this.getList(this.params)
                            } else {
                                this.$message.error(result.message || '操作失败')
                            }
                        }).catch(error => {
                            this.corporateAuditSubmitting = false
                            this.$message.error((error.response && error.response.data && error.response.data.message) || '操作失败')
                        })
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    })
                })
            },
            order_drug_detail(order_id){ //取消订单
                this.drugVisible = true
                getOrderDrugDetail(order_id).then(response => {
                    console.log(response.data);
                    if (response.data.msg_code == '0') {
                        this.orderDrugInfo =[]
                        this.yaopinInfo =[]
                        this.orderData=[]
                        return false
                    } else {
                        this.orderDrugInfo =response.data.info.prescription
                        this.yaopinInfo =response.data.info.yaopindata
                        this.orderData =response.data.info.order_data
                        return false
                    }
                })
                this.cancelOrderForm.order_id = order_id
            },
            handleCancelOrder () {
                this.cancel_order = '';
                this.cancelOrderVisible = false
                this.cancelOrderForm.order_id = ''
                this.cancelOrderForm.other_reason = ''
                this.cancelOrderInput = false;
            },
            cancelReasonSelect(val) {
                if (val == 12) {
                    this.cancelOrderInput = true;
                }else {
                    this.cancelOrderForm.other_reason = ''
                    this.cancelOrderInput = false;
                }
                this.cancelOrderForm.cancel_reason = val;
            },
            submitCancelOrderConfirmAction () {
                if (this.cancelOrderForm.cancel_reason == 0) {
                    this.$message.error('请选择取消原因!')
                    return false;
                }
                if (this.cancelOrderForm.cancel_reason == 12 && this.cancelOrderForm.other_reason == '') {
                    this.$message.error('请输入取消原因!')
                    return false;
                }
                cancelOrderConfirm(this.cancelOrderForm.order_id, this.cancelOrderForm).then( response => {
                    var cancelOrderStatus = response.data.data.refund_status
                    if( cancelOrderStatus == 'WAIT_CHECK') {
                        this.handleCancelOrder()
                        this.$message.success('取消订单成功!')
                        this.getOrders(this.params)
                    } else {
                        this.$message.success('取消订单失败!')
                        this.getOrders(this.params)
                        return false
                    }
                })
            },
            //更新处方
            updateDrug(order_id){
              if(order_id == ''){
                    this.$message({
                        type: 'error',
                        message: '订单ID不能为空!'
                    })
                    return
              }
              //更新处方
              this.$confirm('是否确认更新处方', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {order_id:order_id}
                    updatePreOrder(params).then(response => {
                    if(response.data.data.status){
                      this.$message({
                        type: 'error',
                        message: response.data.data.msg
                    })
                      this.getParams()
                      this.getOrders(this.params)
                    }
              })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });

            },
            exportData (type) {
                this.getParams()
                if (type) {
                    this.params.type = type
                }
                this.params.page = 1
                if (this.params.order_type != 'normal') {
                    this.$message({
                        type: 'error',
                        message: '暂不支持该类型订单导出'
                    })
                    return
                }
                orderExport(this.params).then(response => {
                    if (response.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    } else if (response.data.url) {
                        this.downloadUrl = response.data.url
                        this.downloadName = response.data.filename
                        this.downloadView = true
                    } else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                })
            }
        },
        mounted () {
            if (this.$route.query.tab) {
                this.activeName = this.$route.query.tab
                this.params.order_status = this.$route.query.tab
                this.params.page = 1
            }
            this.params.order_type = this.order_type
            this.getParams()
            this.getStatus()
            this.getOrders(this.params)
            this.getAllSourcesList()
        }
    }
</script>
<style>
  .el-row {
    margin-bottom: 20px;
  &:last-child {
     margin-bottom: 0;
   }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// list.vue?30ca0594